
// This file contains data for the classes offered at the preschool.
 import twosPhoto2 from '../assets/classrooms/twosPhoto2.webp';
// import twosPhoto3 from '../assets/classrooms/twosPhoto3.webp';
import twosPhoto4 from '../assets/teachers/salazarandschultz1.webp';
import threesPhoto from '../assets/classrooms/threesPhoto.webp';
import threesPhoto2 from '../assets/teachers/gudeandjoshi1.webp';
import foursPhoto from '../assets/classrooms/foursPhoto.webp';
import foursPhoto2 from '../assets/teachers/vanwertandleonard1.webp';
import specialsPhoto from '../assets/classrooms/specialsTwo.webp';
import lunchBunchPhoto from '../assets/classrooms/lunchBunchPhoto.webp';
import summerCampPhoto from '../assets/classrooms/summerCampPhoto.webp';

const classesData = [
    {
      id: "two-year-olds",
      teacherImage: twosPhoto2,
      title: "Two Year Old Class",
      fullDesc: `The Binkley two-year-old class is a safe, fun environment where your child will get a gentle introduction to school. We focus on learning through play.We will set your child up for success as they move on in school with a feeling of security to explore and investigate, a foundation in self-help, social, and communication skills, and the fundamentals in preparation for future language, cognitive, and math learning.`,
      image: twosPhoto2,
      image2: twosPhoto4,
      sched: "Mon/Wed/Fri OR Tue/Thu"
    },
    {
      id: "three-year-olds",
      title: "Three Year Old Class",
      fullDesc: `The three-year-old class at Binkley Preschool is a place for children to play, explore and learn. Emphasis is placed on the development of social skills, self-help skills, and fine and gross motor skills. As we play, we learn to share, take turns, and use words to communicate our needs and wants and to solve conflicts.
      
      Through theme-based units, we encourage creativity and exploration. Some examples of our thematic units are All-About-Me, Holidays, Apples, Polar Animals, Seasons, Pets, Farm, and Firefighters.   These are subject to change based on students’ interests. Our typical day consists of Circle time, Center play, Art activities, Storytime, Songs and Games, Snack, Outside playThe threes also participate in Music class.`,
      image: threesPhoto,
      image2: threesPhoto2,
      sched: "Mon/Wed/Fri OR Tue/Thu",
    },
    {
      id: "four-year-olds",
      title: "Four Year Old Class",
      fullDesc: `The Binkley 4-year-old classes are a place where learning, creativity, and exploration are encouraged. Our curriculum gently prepares our students with the academic and social skills necessary for a successful start to Kindergarten.

      Skills are interwoven into a play-based structure with a focus on thematic units.  Some examples of these units include All-about-Me, Friends, Seasons, “Letter Bag,” Space, Dinosaurs, and Holidays.
      The Superstars classes also enrich their curriculum with 3 engaging and fun specials: Music with Ms. Mary Dawn, PE with Mrs. Leonard, and a teacher-led Drama class!`,
      image: foursPhoto,
      image2: foursPhoto2,
      sched: `Schedule: 
      Monday - Friday`,
    },
    {
      id: "specials",
      title: "Specials",
      sections: [
        {
          title: "Drama",
          desc: `All ages at Binkley experience a gentle, age-appropriate introduction to the performing arts. Whether it is pretending to be an autumn leaf or a tiger in the circus, we believe drama allows children to develop confidence, speaking skills, and creative expression.
          
          The 4-year-old classes participate in a Drama “workshop” monthly where they extend picture book stories using their imaginations to act out and explore.`
        },
        {
          title: "Music",
          desc: "Music class introduces students to a variety of musical styles, musical instruments, an understanding of basic musical concepts, as well as social skills such as turn-taking, working in groups, listening to and following directions; gross and fine motor skills; and enjoyment of music"
        },
        {
          title: "Physical Education",
          desc: `Every class enjoys outdoor play on our wonderful playgrounds daily.

          In addition, our 4-year-old classes participate in a Physical Education Class every other week. The primary goal is to teach children the importance of being active and having fun at the same time! 
          
          During this time the children use their gross motor skills (jumping, skipping, dancing, kicking, running, and more), learn about teamwork, and learn the importance of physical fitness.`
        }
      ],
      image: specialsPhoto
    },
    {
      id: "lunch-bunch",
      title: "Lunch Bunch",
      fullDesc: `The Binkley Preschool Lunch Bunch program is a fun, social time that extends the preschool day for one hour. It is an option for our potty-trained students.

      Children eat lunch together, make new friends, and get to know different teachers. Managing a lunch box and enjoying a meal in a different setting gives our preschoolers the opportunity to work on new skills. And, of course, playing on the playground after lunch is always fun! Registration and payment for Lunch Bunch is by semester.

      Lunch Bunch forms for the fall semester are due in August prior to the start of the school year, and sign-ups for Spring Lunch Bunch are sent out in November/December.`,
      image: lunchBunchPhoto,
    },
    {
      id: "summer-camp",
      title: "Summer Camp",
      fullDesc: `Camp is a wonderful, growing opportunity for children and Binkley's Summer Camp is no exception.

      We release Summer Camp info each Spring, so keep an eye out coming up in 2026! `,
      image: summerCampPhoto,
    },
  ];
  
  export default classesData;
  